<script>
  import { isDev, imgSrc } from '$client';
  export let data = [];

  $: length = data.length > 4 ? 4 : data.length;
  const description = 'lorem ipsum dolor sit amet con elit non proident et';
  const createTestCase = header => ({
    header,
    img: {
      data: {
        attributes: {
          url: '',
          alt: '',
        },
      },
    },
    description,
  });
  $: if (!data.length && isDev())
    data = [
      createTestCase('Приедем в течение 2-х часов'),
      createTestCase('Бесплатная погрузка с любого этажа'),
      createTestCase('Фиксируем стоимость до исполнения заказа'),
      createTestCase('Аккуратно демонтируем Ваши вещи'),
    ];
</script>

{#if data.length}
  <ul style={`--columns: ${length};`}>
    {#each data as advantage}
      <li style={advantage.description ? 'padding: 25px 10px ;' : ''}>
        <img
          loading="lazy"
          height="52"
          width="52"
          src={imgSrc(advantage.img.data.attributes.url)}
          alt={advantage.img.data.attributes.alternativeText} />
        <h3 class="header">{@html advantage.header}</h3>
        {#if advantage.description}
          <p class="text">{@html advantage.description}</p>
        {/if}
      </li>
    {/each}
  </ul>
{/if}

<style lang="scss">
  ul {
    display: grid;
    grid-template-columns: repeat(var(--columns), 1fr);
    gap: 30px;

    @media only screen and (max-width: 991.98px) {
      grid-template-columns: 1fr 1fr;
      gap: 20px;
    }

    @media only screen and (max-width: 575.98px) {
      gap: 10px;
    }

    @media only screen and (max-width: 400.98px) {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }

  img {
    @media only screen and (max-width: 575.98px) {
      width: 36px;
      height: 36px;
    }
  }

  li {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
    padding: 25px 30px;

    @media only screen and (max-width: 991.98px) {
      padding: 20px 25px;
    }

    @media only screen and (max-width: 575.98px) and (min-width: 400px) {
      padding: 15px 20px;
    }

    color: #2c333c;
    text-align: center;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 1px 20px #000f5c14;
  }

  .header {
    font-weight: bold;
    font-size: 16px;
    font-family: Vela Sans;
  }

  .text {
    font-size: 16px;
    font-family: Roboto;
    text-align: center;
    opacity: 0.85;
  }
</style>
